import { OPERAZIONI } from "configuration/ConfigurazioneApi";
import { useRichiestaServerLogged } from "hook/useRichiestaServerLogged";
import { useCallback, useState } from "react";




export default function useStepApi(servizio) {
  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()
// hook per invio stupido di step al backend

  const [stepInviati, setStepInviati] = useState(new Set())
 
  function sendStep(step, idPratica, extra){
    sendSteps([{ step, idPratica, extra}])
  }
  function sendSteps(elements){

    let tosend = []

    elements.forEach(({ step, idPratica, extra}) => {
      const unique = JSON.stringify({servizio, step, idPratica, extra})
      if(!stepInviati.has(unique)){
        setStepInviati(prev => new Set(prev).add(unique));
        tosend.push({servizio, step, idPratica, extra})
      }
    })
    if(tosend.length > 0 ){
      postSteps(tosend)
    }
  }

  const getSteps = useCallback(
    (idPratica) => inviaOperazione(OPERAZIONI.STEP_GET, null, {}, { params: { idPratica, servizio },}),
    [inviaOperazione]
  )
  const postSteps = useCallback(
    (steps) => inviaOperazione(OPERAZIONI.STEP_INSERT, {steps:steps}, {}, {}),
    [inviaOperazione]
  )

  return {sendStep, sendSteps, getSteps}

}